module.exports = {
	"id": "PM",
	"name": "Saint Pierre and Miquelon",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.007391,
			"32": 0.007391,
			"33": null,
			"34": 0.192166,
			"35": null,
			"36": 0.051737,
			"37": 0.007391,
			"38": null,
			"39": null,
			"40": 0.066519,
			"41": 0.007391,
			"42": null,
			"43": 0.036955,
			"44": null,
			"45": 0.066519,
			"46": 0.022173,
			"47": 0.118256,
			"48": 0.155211,
			"49": 5.853672,
			"50": 0.118256,
			"51": 0.280858,
			"52": 0.273467,
			"53": 27.997108,
			"54": 8.285311,
			"55": 0.066519,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.022173,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.598671,
			"16": 0.014782,
			"17": 0.044346,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.014782,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.066519,
			"32": 0.014782,
			"33": null,
			"34": 0.014782,
			"35": null,
			"36": 0.014782,
			"37": 0.007391,
			"38": 0.022173,
			"39": null,
			"40": 0.044346,
			"41": 0.014782,
			"42": 0.007391,
			"43": 0.081301,
			"44": null,
			"45": 0.229121,
			"46": null,
			"47": 0.22173,
			"48": 0.391723,
			"49": 10.369573,
			"50": 0.347377,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.014782
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.206948,
			"41": 0.081301,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 3.067265,
			"6": null,
			"7": null,
			"8": 0.14782,
			"9": 0.280858,
			"10": 3.311168,
			"3.1": null,
			"3.2": null,
			"5.1": 0.07391,
			"6.1": 0.036955,
			"7.1": null,
			"9.1": 1.441245
		},
		"ios_saf": {
			"8": 0,
			"10": 7.22141004246,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.194608644567,
			"8.1-8.4": 0.359531224709,
			"9.0-9.2": 0.171519483347,
			"9.3": 2.61677160491
		},
		"android": {
			"3": 0,
			"4": 0.016752881137,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00209411014212,
			"4.1": 0.0604300355297,
			"4.2-4.3": 0.151075088824,
			"4.4": 0.346425649225,
			"4.4.3-4.4.4": 0.349417235142
		},
		"ie": {
			"6": null,
			"7": 0.014782,
			"8": 0.118256,
			"9": 0.096083,
			"10": 0.029564,
			"11": 3.207694,
			"5.5": null
		},
		"op_mob": {
			"0": 0.000899617707075,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000249893807521
		},
		"edge": {
			"12": null,
			"13": 0.288249,
			"14": 4.323735
		},
		"ie_mob": {
			"10": 0.00257225352113,
			"11": 0.0104727464789
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 3.151672
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0.0121203929122
		},
		"and_chr": {
			"0": 11.963025
		},
		"and_ff": {
			"0": 0.013045
		}
	},
	"total": 99.541301
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PM.json
 ** module id = 624
 ** module chunks = 0
 **/